import React from 'react';
import { FaMoneyBillAlt } from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiPayMoney } from "react-icons/gi";
import { NavLink } from 'react-router-dom'; // Import NavLink
import './layout.css'; // Make sure this path is correct
import { GiMoneyStack } from "react-icons/gi";

const PayrollLayout = ({ children }) => {

  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
      <FaMoneyBillAlt className="leave-policy-icon" />
        Payroll Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="emp-payroll-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/emp-payroll"
              >
                <GiMoneyStack   className="nav-icon" /> Employee Payroll
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="process-payroll-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/process-payroll"
              >
                <GiPayMoney  className="nav-icon" /> Process Payroll
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/payroll-report"
              >
                <FaMoneyBillTransfer  className="nav-icon" />Payroll Report
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default PayrollLayout;
